import { render, staticRenderFns } from "./card.vue?vue&type=template&id=2e9039c4&scoped=true&lang=pug&"
import script from "./card.vue?vue&type=script&lang=js&"
export * from "./card.vue?vue&type=script&lang=js&"
import style0 from "./card.vue?vue&type=style&index=0&id=2e9039c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9039c4",
  null
  
)

/* custom blocks */
import block0 from "./card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsroomIconGroup: require('/home/ubuntu/nuxt/bonkers/releases/20230928165100/components/newsroom/icon-group.vue').default})
